export const fmtCurrency = (v) =>
    new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(v || 0));